module.exports = __webpack_public_path__ + "img/third-1-opened.543af078.webp";